import * as apiCommon from '@/api/apiCommon'

// 问卷调查
const apiName = '/webapi/answer'

// 获取问卷列表
export function getAnswerList(data) {
	return apiCommon.index(apiName + '/surveyList', data)
}

//获取问卷详情
export function getAnswer(data) {
	return apiCommon.index(apiName + '/index', data)
}

// 提交问卷
export function saveAnswer(data) {
	return apiCommon.save(apiName + '/save', data)
}